import { getRegCart } from '../selectors/shared';
import { getAttendeeId } from '../registrationForm/regCart/selectors';
import Logger from '@cvent/nucleus-logging';
const LOG = new Logger('redux/modules/travelCart/passkeyHotelRequest');

/**
 * handler for passkey select hotel button
 * @param eventRegistrationId
 * @returns {Function}
 */
export function selectPasskeyHotel(eventRegistrationId) {
  return async (dispatch, getState) => {
    const state = getState();
    const { accessToken, clients: { passkeyClient } } = state;
    const regCart = getRegCart(state);
    const inviteeId = getAttendeeId(regCart, eventRegistrationId);
    const response = await passkeyClient.getNewRequestRedirectUrl(accessToken, inviteeId);
    if (response.redirectUri) {
      window.open(response.redirectUri, null);
    } else {
      LOG.error(`error redirecting to passkey for ${inviteeId} for new request`);
    }
  };
}

/**
 * handler for passkey edit request
 * @param eventRegistrationId
 * @param hotelReservationId Specific reservation for which we have to redirect to modification
 * @returns {Function}
 */
export function modifyPasskeyRequest(hotelReservationId) {
  return async (dispatch, getState) => {
    const { accessToken, clients: { passkeyClient } } = getState();
    const response = await passkeyClient.getEditRequestRedirectUrl(accessToken, hotelReservationId);
    if (response.redirectUri) {
      window.open(response.redirectUri, null);
    } else {
      LOG.error(`error redirecting to passkey for ${hotelReservationId} for edit request`);
    }
  };
}

